/**
 * @flow
 * @relayHash ec54e9ba2bcfe2b18546156587df0d69
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteSupplierCategoryMutationVariables = {|
  id: string
|};
export type DeleteSupplierCategoryMutationResponse = {|
  +deleteSupplierCategory: {|
    +id: string
  |}
|};
export type DeleteSupplierCategoryMutation = {|
  variables: DeleteSupplierCategoryMutationVariables,
  response: DeleteSupplierCategoryMutationResponse,
|};
*/


/*
mutation DeleteSupplierCategoryMutation(
  $id: String!
) {
  deleteSupplierCategory(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteSupplierCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SupplierCategoryModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteSupplierCategoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteSupplierCategoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteSupplierCategoryMutation",
    "id": null,
    "text": "mutation DeleteSupplierCategoryMutation(\n  $id: String!\n) {\n  deleteSupplierCategory(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f46a46c07e48a64c61863ad9d77821be';
module.exports = node;
